import { EXTENSIONES_DDJJ, MAX_DDJJ_BYTES } from '../constants/modal-carga-ddjj.jsx'

const extension = (nombre = '') => {
  const i = nombre.lastIndexOf('.')
  return i >= 0 ? nombre.slice(i).toLowerCase() : ''
}

/**
 * PBI 81147: estado de cada regla para los hints. null = sin archivo (hint en info).
 * Reglas fijas de la carga del médico (2 MB, imágenes + PDF).
 * @param {File | null} archivo
 * @returns {{ formatoOk: boolean | null, tamanioOk: boolean | null, valido: boolean }}
 */
export function validarArchivoDdjj(archivo, { maxBytes = MAX_DDJJ_BYTES, extensiones = EXTENSIONES_DDJJ } = {}) {
  if (!archivo) return { formatoOk: null, tamanioOk: null, valido: false }
  const formatoOk = extensiones.includes(extension(archivo.name))
  const tamanioOk = archivo.size > 0 && archivo.size < maxBytes
  return { formatoOk, tamanioOk, valido: formatoOk && tamanioOk }
}

export const varianteHint = (ok) => {
  if (ok === null) return 'info'
  return ok ? 'success' : 'error'
}
